// Kişisel geri al / yinele. Silinen çizimler sunucuda kısa süre saklandığı için
// geri alma, çizimi özgün yazarı ve kimliğiyle geri getirir (ann:restore).
import type { Annotation } from '../../shared/protocol';
import { createStore } from './store';
import type { LessonConnection } from './connection';
import { lesson } from './lesson';

type Entry = { kind: 'add' | 'remove'; anns: Annotation[] };

export class History {
  private undoStack: Entry[] = [];
  private redoStack: Entry[] = [];
  readonly state = createStore({ canUndo: false, canRedo: false });

  push(entry: Entry) {
    if (!entry.anns.length) return;
    this.undoStack.push(entry);
    if (this.undoStack.length > 200) this.undoStack.shift();
    this.redoStack = [];
    this.emit();
  }

  undo(conn: LessonConnection | null) {
    const e = this.undoStack[this.undoStack.length - 1];
    if (!e || !conn || !this.apply(conn, e, e.kind === 'add' ? 'remove' : 'add')) return;
    this.undoStack.pop();
    this.redoStack.push(e);
    this.emit();
  }

  redo(conn: LessonConnection | null) {
    const e = this.redoStack[this.redoStack.length - 1];
    if (!e || !conn || !this.apply(conn, e, e.kind)) return;
    this.redoStack.pop();
    this.undoStack.push(e);
    this.emit();
  }

  private apply(conn: LessonConnection, e: Entry, op: 'add' | 'remove'): boolean {
    const ids = e.anns.map((a) => a.id);
    if (op === 'remove') {
      if (!conn.send({ t: 'ann:delete', ids })) return false;
      lesson.remove(ids);
    } else {
      if (!conn.send({ t: 'ann:restore', ids })) return false;
      lesson.add(e.anns);
    }
    return true;
  }

  private emit() {
    this.state.set({ canUndo: this.undoStack.length > 0, canRedo: this.redoStack.length > 0 });
  }
}
